import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
    
import * as _ from 'lodash';
import { TrackeritemService } from '../../services/trackeritem.service';
import { TrackerRest } from '../../services/tracker.rest';
import { UiService } from '../../../../core/services/core.ui.service';
import { StateService } from '@uirouter/angular';
import { GfTranslateService } from '../../../../core/services/core.translate.service';
import { ModalComponent } from '../../../../core/config/core.modal-helpers';
  
  @Component({
    selector: 'trackeritem-move-modal',
    template: require('./trackeritem.move.component.html'),
  })
  export class TrackeritemMoveModalComponent extends ModalComponent implements OnInit {
    @Input() trackeritem: any;
    @Input() tracker: any;
    @Input() project: any;
    @Output() onUpdate: EventEmitter<any> = new EventEmitter<any>();
  
    params: any;
    tags: any[] = [];
    errors: any = {};
    isLoaded = false;
    isLoadingTracker = false;
    trackeritemSaving = false;
    hasExtraFields = false;
    title = '';
    subtitle = '';
    footerMessage = '';
    wysiwyg_details_id = "wysiwyg_details_edit";
    acls: any = {};
    trackers: any = [];
    trackersList: any = [];
    selectedTrackerId: any;
    selectedTracker: any = null;
    newTrackeritem: any;
  
    constructor(
      private trackeritemService: TrackeritemService,
      private trackerRest: TrackerRest,
      private uiService: UiService,
      private stateService: StateService, 
      private translateService: GfTranslateService
    ) {
      super();
    }
  
    ngOnInit(): void {
      this.trackeritemService.setTrackeritem(this.trackeritem);
  
      this.params = {
        id: 'ti-edit',
        title: '[#' + this.trackeritem.id + '] - ' + this.trackeritem.summary,
        subtitle: '',
        footerMessage: ''
      };

      this.acls = {
        canUpdate: true
      };
  
      this.title = this.params.title;
      this.subtitle = this.params.subtitle;
      this.footerMessage = this.params.footerMessage;
  
      this.isLoaded = true;
      this.getTargetTrackersList();
    }

    getTargetTrackersList() {
      this.trackersList = _.filter(_.get(this.project, 'rel.trackers', []), (tracker) => {
        const trackerId = tracker.tracker_id;
        const permissions = this.project.rel.permissions.trackers[trackerId];
        return permissions && permissions.canSubmit && trackerId != this.tracker.id;
      });

      this.trackers =  {
        id: 'trackers',
        fieldName: this.translateService.translate('Trackers'),
        fieldElements: _.concat(
          { id: -1, value: -1, label: "Select tracker" },
          _.map(this.trackersList, (tracker) => {
            return { id: tracker.tracker_id, value: tracker.tracker_id, label: tracker.tracker_name };
          })
        )
      };

      this.selectedTrackerId = this.trackers.fieldElements[0].id;

    }

    selectTracker(trackerId: any) {
      this.isLoadingTracker = true;
      this.trackerRest.details(trackerId, { rel: 'fields' })
      .then((ret: any) => {
        this.selectedTracker = ret;
        this.newTrackeritem = this.copyTrackerItemWithExtraFields(this.trackeritem, this.selectedTracker);
        this.isLoadingTracker = false;
      }, (err: any) => {
        this.isLoadingTracker = false;
      });
    }

    copyTrackerItemWithExtraFields(trackerItem, tracker) {
      // Create a deep copy of the tracker item
      const copiedTrackerItem = {
        id: trackerItem.id,
        extraFields: {}
      };
   
      // Iterate over fields in tracker
      _.forEach(tracker.fields, (field, key) => {
          // Check if the field is required or has a correspondence through the alias 
          // (we exclude the status field, as it's handled in the backend)
          const isRequired = (field.isExtraField && field.isEnabled && field.isRequired && field.fieldType != 7);

          if (isRequired) {
              this.hasExtraFields = true;
              copiedTrackerItem.extraFields[key] = {
                  id: field.id,
                  alias: field.alias,
                  fieldId: field.id,
                  fieldName: field.fieldName,
                  fieldType: field.fieldType,
                  fieldData: null,
                  fieldElements: field.fieldElements,
                  fieldOrder: field.fieldOrder,
                  useWorkflow: field.useWorkflow,
                  attribute1: field.attribute1,
                  attribute2: field.attribute2,
                  isExtraField: field.isExtraField
              };
          }
      });

      return copiedTrackerItem;
  };
  
  cancel(): void {
    this.closeModal();
  }
  
  setStatus(status: any) {
    this.newTrackeritem.extraFields.status.fieldData = status;
  }

  submitTrackeritem(setAssigneeOnly = false): Promise<any> {
      this.trackeritemSaving = true;
      return new Promise((resolve, reject) => {
        if (!this.trackeritem.tracker.id) {
          this.errors = {
            tracker: {
              error: 'Required field',
              hasError: true
            }
          };
          this.trackeritemSaving = false;
          resolve(null);
          return;
        }
  
        this.trackeritemService.move(_.cloneDeep(this.newTrackeritem), this.selectedTracker.id, { stopRedirection: false, setAssigneeOnly })
          .then(() => {
            this.closeModal();
            this.uiService.message.showSuccess('The tracker item has been moved successfully', 'Tracker item move');
            this.stateService.go('home.project.summary.tracker.item.edit', { unixName: this.selectedTracker.project.unixName, tracker: this.selectedTracker.id, id: this.newTrackeritem.id }, { inherit: false })
            resolve(null);
          }, (errors: any) => {
            this.errors =  errors;
            this.uiService.message.showError('There was an error moving the tracker item, please make sure you have properly set all required fields', 'Tracker item move');
            reject(errors);
          })
          .then(() => {
            this.trackeritemSaving = false;
          })
      });
    }
  }
  